import React from 'react';
import { formatDateStandard } from 'smart-react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  editContentSlider,
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  BooleanFlagFilterCell,
  GridFlag,
}) => {
  const dataColumns = [
    {
      field: 'IntegrationCredId',
      title: 'Integration Cred Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'UserId',
      title: 'User Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'ConnectionId',
      title: 'Connection Id',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
      excludeFromFilter: true,
    },
    {
      field: 'LoginUsername',
      title: 'Login Username',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: (props) => (
        <td
          className='edit-link'
          onClick={() => {
            editContentSlider(props.dataItem);
          }}
        >
          {props.dataItem.LoginUsername}
        </td>
      ),
    },
    {
      field: 'PlainTextPassword',
      title: 'Plain Text Password',
      editable: false,
      show: false,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'PlainTextSessionKey',
      title: 'Plain Text Session Key',
      editable: false,
      show: false,
      width: '250px',
      minResizableWidth: 50,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
    },
    {
      field: 'SessionExpiresAt',
      title: 'Session Expiration Date',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      cell: (props) => (
        <td>{formatDateStandard(props.dataItem.SessionExpiresAt)}</td>
      ),
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'SessionExpiresAt',
        }),
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: true,
      width: '200px',
      minResizableWidth: 50,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: true,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
    },
  ];

  return dataColumns;
};
export default DataColumns;
